import React from "react";

const LevelGrid = ({ levels, selectedLevel, onLevelClick }) => {
  return (
    <div
      className="gridlevel"
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "10px",
      }}
    >
      {levels.map((level) => (
        <button
          key={level.level_name}
          onClick={() => onLevelClick(level)}
          style={{
            width: "2rem",
            height: "2rem",
            backgroundColor:
              selectedLevel === level.level_name
                ? "#9dcc06"
                : level.accessed == 1
                ? "green"
                : "gray",
            color: "#fff",
            border: "none",
            borderRadius: "1.5rem",
            cursor: "pointer",
            fontSize: "0.85rem",
          }}
        >
          {level.level_name}
        </button>
      ))}
    </div>
  );
};

export default LevelGrid;
